module.exports = __webpack_public_path__ + "static/media/pencil.fa3cdb95.png";